class FreeShippingMeter extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.threshold = parseFloat(window?.free_shipping_price) || 0;
    this.config = window?.free_shipping_text || {};
  }

  connectedCallback() {
    this.progressBar = this.querySelector('[data-shipping-progress]');
    this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.textEnabled = this.progressBar?.dataset?.textEnabled === 'true';

    if (!this.threshold || !this.progressBar || !this.progressMeter || !this.messageElement) {
      console.warn('FreeShippingMeter: Missing configuration or DOM elements.');
      return;
    }

    this.init();
    this.attachListeners();
  }

  attachListeners() {
    document.addEventListener('cart:updated', () => this.refresh());
    document.addEventListener('cart:refresh', () => this.refresh());

    // Fallback polling (optional safety)
    document.addEventListener('DOMContentLoaded', () => this.refresh());
  }

  async init() {
    await this.refresh();
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      this.cart = await response.json();
      this.calculateProgress();
    } catch (error) {
      console.error('FreeShippingMeter error:', error);
    }
  }

  calculateProgress() {
    if (!this.cart) return;

    let total = (this.cart.total_price || 0) / 100;

    const progress = Math.min((total / this.threshold) * 100, 100);

    this.updateUI(total, progress);
  }

  updateUI(total, progress) {
    const remaining = Math.max(this.threshold - total, 0);

    this.progressMeter.style.width = `${progress}%`;

    if (this.textEnabled) {
      this.progressMeter.textContent = `${progress.toFixed(0)}%`;
    }

    this.updateMessage(total, remaining, progress);
    this.updateProgressClass(progress);
  }

  updateMessage(total, remaining, progress) {
    let message = '';

    if (total <= 0) {
      message = `${this.config.free_shipping_message || ''} ${this.formatMoney(this.threshold)}`;
      this.progressBar.classList.add('progress-hidden');
    } 
    else if (progress >= 100) {
      message = this.config.free_shipping_message_1 || 'You unlocked free shipping!';
      this.progressBar.classList.remove('progress-hidden');
    } 
    else {
      message = `${this.config.free_shipping_message_2 || ''} ${this.formatMoney(remaining)} ${this.config.free_shipping_message_3 || ''} ${this.config.free_shipping_message_4 || ''}`;
      this.progressBar.classList.remove('progress-hidden');
    }

    this.messageElement.textContent = message;
  }

  updateProgressClass(progress) {
    this.progressBar.classList.remove(
      'progress-30',
      'progress-60',
      'progress-100',
      'progress-free'
    );

    if (progress <= 30) {
      this.progressBar.classList.add('progress-30');
    } else if (progress <= 60) {
      this.progressBar.classList.add('progress-60');
    } else if (progress < 100) {
      this.progressBar.classList.add('progress-100');
    } else {
      this.progressBar.classList.add('progress-free');
    }
  }

  formatMoney(amount) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(amount * 100, window.money_format);
    }
    return amount.toFixed(2);
  }
}

window.addEventListener('load', () => {
  if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', FreeShippingMeter);
  }
});
